<template>
  <div>
    <a-modal
      wrap-class-name="report-detail-modal-wrapper"
      width="900px"
      :mask-closable="false"
      :visible="visible"
      :footer="null"
      :title="title"
      @cancel="$emit('onCancel')"
    >
      <div class="box">
        <div class="sub-box">
          <div style="width: 100%">
            <p>本报告照片</p>
            <div class="images right-line" v-if="data.workReportDetail != undefined">
              <img
                :src="item"
                v-for="(item, index) in data.workReportDetail.report_value.pictures"
                style="
                  width: 200px;
                  height: 200px;
                  margin-right: 10px;
                  cursor: pointer;
                "
                :key="index"
                @click="handlePreviewSingle(item)"
              />
            </div>
          </div>
        </div>
        <div class="sub-box">
          <div style="width: 100%">
            <p>已通过审核的照片(数值越小越相似)</p>
            <div class="images">
              <div class="checking" v-if="showCheck">
                <i class="el-icon-loading" v-if="checkloading"></i>
                <p v-if="checkloading">校验中，请稍等...</p>
                <p v-if="checkloaded" style="color: green">{{ compareMessage }}</p>
              </div>

              <img
                :src="item"
                v-for="(item, index) in repeatPicture"
                style="
                  width: 200px;
                  height: 200px;
                  margin-left: 10px;
                  cursor: pointer;
                "
                :key="index"
                @click="handlePreviewSingle(item)"
              />
            </div>
          </div>
        </div>
      </div>
    </a-modal>
    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>
  </div>
</template>
<script>
export default {
  props: ["title", "visible", "data", "companyId"],
  data() {
    return {
      previewVisible: false,
      previewImage: "",
      checkloading: true,
      checkloaded: false,
      checking: true,
      showCheck: true,
      repeatPicture: [],
      compareMessage: ''
    };
  },
  watch: {
    visible: {
      handler(newValue, oldValue) {
        if (!newValue) {
          this.repeatPicture = [];
        }
      },
      immediate: true
    },
    data: {
      handler(newValue, oldValue) {
        if(newValue.id){
          this.comparePicture();
        }
      },
      immediate: true
    },
  },
  methods: {
    initParams(){
       that.repeatPicture = [];
       console.log(1);
    },
    async comparePicture() {
      this.showCheck = true;
      this.checkloading = true;
      this.checkloaded = false;
      let result = await this.$http.post("/WorkReport/comparePicture", {
        reportId: this.data.id,
        companyId: this.companyId
      });
      if (result.data.status == 1) {
        this.checkloading = false;
        this.checkloaded = true;
        this.compareMessage = result.data.msg;
      } else {
        this.checking = false;
        this.showCheck = false;
        this.repeatPicture = result.data.data;
        this.compareMessage = result.data.msg;
      }
    },
    // 单张图片预览
    handlePreviewSingle(url) {
      this.previewVisible = true;
      this.previewImage = url;
    },
    // 关闭预览
    handleCancel() {
      this.previewVisible = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.box {
  display: flex;
  width: 100%;
  height: 400px;

  .sub-box {
    display: flex;
    width: 50%;

    p {
      width: 100%;
      text-align: center;
      height: 30px;
      line-height: 30px;
      font-weight: 500;
    }

    .right-line {
      border-right: 1px solid #dbdbdb;
    }
    .images {
      width: 100%;
      height: 90%;

      img {
        border: 1px solid rgb(238, 238, 238);
        border-radius: 3px;
      }
    }

    .checking {
      margin: 0 auto;
      width: 200px;
      text-align: center;
      color: #1890ff;
    }
  }
}
</style>